import { render, staticRenderFns } from "./VErrorDialog.vue?vue&type=template&id=4a1032b4&"
import script from "./VErrorDialog.vue?vue&type=script&lang=js&"
export * from "./VErrorDialog.vue?vue&type=script&lang=js&"
import style0 from "./VErrorDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports